import { type PhaseCompleteRules } from '../core';
import { CommentStatus } from './context/threat-vector-comment/entity';
import { PhaseName } from './phases';
import { type TraV1 } from './tra-v1';

export const phaseCompleteRules: PhaseCompleteRules<TraV1> = {
    [PhaseName.Details]: (_) => {
        return null;
    },
    [PhaseName.RiskLikelihood]: (_) => {
        return null;
    },
    [PhaseName.ProtectionGoals]: (_) => {
        return null;
    },

    [PhaseName.Settings]: (_) => {
        return null;
    },
    [PhaseName.TacticsAndTechniques]: (_) => {
        return null;
    },
    [PhaseName.ScopeOfTra]: (_) => {
        return null;
    },
    [PhaseName.ScopingAssets]: (tra) => {
        const result = [];

        const assetsInScope = tra.assets
            .getAll()
            .filter((asset) => asset.inScope);
        const assetHasType = assetsInScope.every(
            (asset) => asset.attckAssetTypeId !== undefined,
        );
        const hasSomeImpact = assetsInScope.some(
            (asset) =>
                tra.assetProtectionGoalImpacts.getByAssetId(asset.id).length,
        );
        if (assetsInScope.length < 2) {
            result.push('At least two assets must be in scope');
        }
        if (!assetHasType) {
            result.push('All assets in scope must have a type');
        }
        if (!hasSomeImpact) {
            result.push('At least one asset in scope must have an impact');
        }
        return result.length ? result : null;
    },
    [PhaseName.ThreatPathAndVectors]: (tra) => {
        const result = [];
        const traThreatPaths = tra.threatPaths.getAll();
        const traThreatVectors = tra.threatVectors.getAll();
        const hasProtectionGoalsSet = traThreatVectors.every(
            (vector) => vector.protectionGoalId,
        );
        if (traThreatPaths.length === 0) {
            result.push('At least one threat path must be defined');
        }
        if (traThreatVectors.length === 0) {
            result.push('At least one threat vector must be defined');
        }
        if (!hasProtectionGoalsSet) {
            result.push('All threat vectors must have a protection goal set');
        }
        return result.length ? result : null;
    },
    [PhaseName.RelationTypes]: (_) => {
        return null;
    },
    [PhaseName.CreateTreatments]: (tra) => {
        const result = [];

        const allAccepted = tra.threatVectors.getAll().every((threatVector) => {
            const comments = tra.threatVectorComments.getByThreatVectorId(
                threatVector.id,
            );
            return (
                comments[comments.length - 1]?.status === CommentStatus.Accepted
            );
        });
        if (!allAccepted) {
            result.push('All Residual risks must be accepted');
        }
        return result.length ? result : null;
    },
    [PhaseName.Reporting]: (_) => null,
};
